// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"1":"student","328":"admin","756":"professor"}[chunkId] || chunkId) + "." + {"1":"a2ee758e","328":"ea769802","486":"ff112a02","756":"ecd085a5"}[chunkId] + ".js";
};